import React from "react";

const es_astara = {
  HI: "¡Hola!",
  INVITATION_MSG:
    "Estás entrando a la pasarela de contratación para financiar tu vehículo de Astara Store.",
  WHAT_WILL_YOU_NEED: "Qué necesitarás?",
  DOCUMENT_RECOMMENDATION: "Para llevar a cabo tu petición financiera deberás:",
  DNI_OR_NIE: "Identificarte con tu DNI o NIE",
  IMAGE_ID_NIE_EU:
    "Imagen del pasaporte o parte frontal del documento de identidad",
  PASSPORT_FRONT:
    "Foto página bio del pasaporte o parte frontal del documento de identidad",
  NIE_EU_PASSPORT:
    "En caso de tener NIE Europeo sin foto, además te pediremos el pasaporte o tu documento nacional de identidad",
  SPANISH_ACCOUNT: "Aportar documentación",
  INCOME: "Aportar documentación",
  SPANISH_ACCOUNT_DETAIL:
    "Te pediremos una serie de documentos para verificar tu situación financiera y luego procederemos a la firma del contrato.",
  CONGRATULATIONS: "¡Ya estás identificad@!",
  CONGRATULATIONS_SIGNATURE_NOT_AVAILABLE: "Documentación aportada",
  CONGRATULATION_DOCUMENTS_UPLOADED: "Documentación aportada",
  CONGRATULATIONS_APPROVED_END: "¡Felicidades!",
  THANKS_DOCUMENTATION_UPLOADED:
    "Verificaremos que todo esté correcto para firmar el contrato.",
  APPLICATION_PENDING_APPROVAL:
    "Verificaremos que todo esté correcto para firmar el contrato",
  SIGNATURE_MODULE_YET_NOT_AVAILABLE: (
    <>
      <p>
        Una vez verificado, nos pondremos en contacto contigo para comentar los
        detalles de la oferta y firmar el contrato.
      </p>
      <p>Muchas gracias por tu confianza.</p>
    </>
  ),
  PENDING_LENDER_APPROVAL: (
    <>
      <p>
        La entidad financiera está analizando tu documentación y estudiando la
        propuesta.
      </p>
      <p>
        Te informaremos por correo electrónico tan pronto tengamos una respuesta
        definitiva de la entidad financiera.
      </p>
    </>
  ),
  THANKS_LOAN_FORM_COMPLETED:
    "Ahora solo tienes que completar las siguientes acciones",
  DOCS_COMPLETED: "Documentación aportada",
  LOAN_ANALYSING: "Muchas gracias por tu confianza.",
  THANKS_LOAN_FORM_COMPLETED_AND_PREAPPROVED_DOCS_AND_SIGNATURE_REDIRECT:
    "Ahora solo tienes que completar las siguientes acciones",
  THANKS_LOAN_FORM_COMPLETED_AND_PREAPPROVED: (
    <>
      <p>
        La documentación ha sido aportada correctamente. Verificaremos que todo
        esté correcto para firmar el contrato
      </p>
    </>
  ),
};

export default es_astara;
